/**
 * Keyboard escape hatch past the navigation.
 *
 * Visually hidden until focused, then pinned to the top-left. This is the
 * first focusable element in the document.
 */
const SkipLink = ({ targetId = 'main-content' }) => (
  <a className="skip-link" href={`#${targetId}`}>
    Skip to main content
  </a>
);

export default SkipLink;
